Auth = require 'app/scripts/db/auth'
LargeAvatarView = require 'app/scripts/views/member-menu-profile/large-avatar-view'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/mini_profile'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class MemberMiniProfileView extends View
  initialize: ->
    super
    @listenTo @model, 'change change:avatarUrl change:avatarSource', @frameDebounce @render
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  viewTitleKey: 'member'
  displayType: 'mod-mini-profile'

  delegateEvents: (events) ->
    miniprofileEvents =
      'click .js-profile': 'showProfile'
      'click .js-view-large': 'viewLarge'

    super(_.extend(miniprofileEvents, events || @events))

  render: ->
    data = @model.toJSON()
    data.isMe = Auth.isMe(@model)
    data.showEmail = data.email? && !data.isMe
    if !data.email? && @model.get('memberType') == "ghost" && !@loaded
      @loadEmail()

    @$el.html template(data)

    @renderMenu()

    @

  renderMenu: ->
    return

  loadEmail: ->
    ModelLoader.loadMemberEmail @model.id
    .then =>
      @loaded = true
    .done()

  showProfile: ->
    track("Mini Profile", "Click Profile")
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'link'
        actionSubjectId: 'fullNameProfileLink'
        source: 'miniProfileInlineDialog'
    return

  viewLarge: (e) ->
    Util.stop(e)
    track("Mini Profile", "View Large Avatar")
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'avatar'
        actionSubjectId: 'miniProfileAvatar'
        source: 'miniProfileInlineDialog'

    PopOver.pushView
      elem: @$(e.target)
      view: new LargeAvatarView({ @model, @modelCache })
    return
